enum ProgramAgendaStatus {
  SCHEDULED = "SCHEDULED",
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  NOT_COMPLETED = "NOT_COMPLETED",
  COMPLETED = "COMPLETED"
}

export default ProgramAgendaStatus;
